export const trimWhiteSpaces = (text: string) => text?.replace(/\s/g, "");
export const trimHyphens = (text: string) => text?.replace(/-/g, "");
